import React from "react";
import { ActivationQueryData_datoCmsActivationConfig } from "../../../pages/__generated__/ActivationQueryData";

interface ConfigContextType {
  config: ActivationQueryData_datoCmsActivationConfig;
}

export const ConfigContext = React.createContext<ConfigContextType>({
  config: null
});

/**
 * Provide Activation configuration from DatoCMS
 * This provider let hooks in the Activation app access these config values.
 */
export default function ConfigProvider({
  children,
  config
}: {
  children: JSX.Element;
  config: ActivationQueryData_datoCmsActivationConfig;
}) {
  return (
    <ConfigContext.Provider
      value={{
        config
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
}
